import {DataGridPro} from '@mui/x-data-grid-pro'
import {envBackHost} from 'GLOBAL/envVariables'
import dayjs from 'dayjs'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import {customerLongTermUnusedColumn} from 'pages/customer/dataConfig/declearColumns'
import {customerLeakageFilter} from 'pages/customer/dataConfig/declearFilters'
import {customerLongTermUnusedUserRows} from 'pages/customer/dataConfig/declearRows'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {getLongTermUnusedList} from 'utils/apiCalling/api'
import CustomPagination from 'utils/designSytem/CustomPagination'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {scrollTop} from 'utils/func/justUtils'
import {reduxType} from 'utils/interface/reduxType'
import {toolTipText} from 'utils/toolTips/toolTipText'

const CustomerUnused = (props: any) => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  const unusedOptionsDataInit: any = {
    officeName: '',
    longtermStandard: '',
  }
  const officeInfo = useSelector((state: reduxType) => state.officeInfo)
  const cooperInfo = useSelector((state: reduxType) => state.cooperInfo)
  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const [unusedList, setUnusedList] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [filter, setFilter] = useState<any>(customerLeakageFilter)
  const [unusedOptionsData, setunusedOptionData] = useState<any>(unusedOptionsDataInit)
  const [shouldCallApi, setShouldCallApi] = useState<boolean>(false)

  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  const getUnusedCustomerList = () => {
    const checkBusan = String(officeInfo.value).slice(0, 2) === '13'
    let selectedFilter = filter
    if (checkBusan) {
      selectedFilter = {
        ...filter,
        searchOption: {
          customerNumber: true,
        },
      }
    }
    getLongTermUnusedList(officeInfo, cooperInfo, selectedFilter, {
      success: (res: any) => {
        console.log('res', res)
        setUnusedList(res)
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
      count: (count: number) => {
        setTotalCount(count)
      },
    })
  }

  const getOfficeDetailInfo = async () => {
    axiosWithAuth()
      .get(`${envBackHost}/office/${officeInfo.value}`)
      .then((res: any) => {
        let response = res.data?.res[0]

        if (response.officeId === 'all') {
          setunusedOptionData({
            ...unusedOptionsData,
            longtermStandard: 0,
            officeName: response.officeName,
          })
        } else {
          setunusedOptionData({
            ...unusedOptionsData,
            longtermStandard: response.officeCustomerTypeModel[0].longtermStandard,
            officeName: response.officeName,
          })
        }
      })
  }

  const columns: any = customerLongTermUnusedColumn(filter)
  const rows = customerLongTermUnusedUserRows(unusedList)
  const searchHandler = () => {
    setFilter((prev: any) => ({...prev, page: 1}))
    setShouldCallApi(true)
  }
  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/
  useEffect(() => {
    if (shouldCallApi) {
      getUnusedCustomerList()
      setShouldCallApi(false)
    }
  }, [filter, shouldCallApi])

  useEffect(() => {
    scrollTop()
    getUnusedCustomerList()
    getOfficeDetailInfo()
  }, [officeInfo, cooperInfo, filter.rowPerPage, filter.page])
  /*********************************************************************
   * 5. Page configuration
   *********************************************************************/
  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.customerUnused.description}
        tooltipText={toolTipText.customerUnused.text}
        filter={filter}
        id={'customer-unused'}
        setFilter={setFilter}
        searchCallback={searchHandler}
        total={totalCount}
        hideSearch={true}
        control={[]}
        actions={['unused']}
        date={[{date: dayjs().format('YYYYMMDD')}]}
        asValue={unusedOptionsData}
        searchOptions={[]}
        checkData={null}
        onDelete={null}
        onCancel={null}
        setTypeName={null}
      >
        <DataGridPro
          rows={rows}
          columns={columns}
          rowHeight={200}
          disableColumnMenu
          loading={loading}
          autoHeight={true}
          paginationMode={'server'}
          hideFooterPagination={true}
          pagination={true}
          hideFooter={true}
          sx={{
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
          }}
        />
        <CustomPagination filter={filter} setFilter={setFilter} totalCount={totalCount} />
      </MeterariumPageLayout>
    </>
  )
}

export default CustomerUnused
